<template>
    <div id="radioBot" ref="rootElem" class="rootElem radiobot-variables">
        <router-view v-if="showRouter"/>
        <div id="divDPI" style="position:absolute; width:1in"></div>

        <div id="divLoadingPanel" 
            v-show="GET_jobLoaded ? !GET_elemsLoaded : true"
            style="
                z-index:100; 
                opacity:0.7; 
                background:#FFFFFF; 
                position:fixed; 
                width:100%; 
                height:100%
            "
        > 
            <table style="position:absolute; left:50%; top:50%; margin-left:-200px; margin-top:-70px;">
                <tr>
                    <td align="center">
                        <img 
                            :src="require('./assets/imgs/loading.gif')" 
                            alt="Carregando ..." 
                            height="140" 
                            width="400"
                        />
                    </td>
                </tr>
                <tr>
                    <td align="center">
                        <strong><span id="divLoadingPanelMsg">Por favor aguarde, <br>Carregando dados ...</span></strong><br>
                    </td>
                </tr>
            </table>
        </div>

        <div id="div_grid_container"
            @mousemove="mouseTarget = $event.target">
            <headerCMP style="grid-area: header;"></headerCMP>
            <!-- <div id="header" :style="{ background : GET_colorTheme.header }">
                <div id="div_appTitle">
                    <span class="appTitleText">RM RadioBot</span>
                </div>
            </div>

            <div id="div_toolBars" 
                :style="{ background : GET_colorTheme.toolbar }"
            >
                <div v-for="(toolbar, id) of GET_appToolbars" :key="id" class="toolbarContainer">
                    <toolbarCMP
                    :id="id"
                        :buttons="toolbar"
                    ></toolbarCMP>
                    <div v-if="id !== gConsts.ui.toolbar.ids.OTHER" class="toolbarSeparator"></div>
                </div>
            </div> -->

            <div class="div_workArea_container">

                <div id="div_workArea" 
                    ref="workArea"
                    class="workArea"
                    :data-cursor-type="workAreaCursorType"
                    @contextmenu.prevent=""
                    :style="{ 
                        background : GET_colorTheme.workArea,
                        position : 'relative'
                    }"
                >
                    <div id="div_imgOrigin"
                        ref="div_imgOrigin"
                        v-if="GET_togglesImgOrigin"
                        style="position:absolute; height: 100%; width: 100%;"
                    >
                        <img id="img_imgOrigin"
                            ref="img_imgOrigin"
                            :style="{
                                width  : (imgOrigin.ratio < imgOrigin.containerRatio) ? 'auto' : '100%',
                                height : (imgOrigin.ratio < imgOrigin.containerRatio) ? '100%' : 'auto',
                                zIndex : 10
                            }"
                            :src="imgOriginSrc"
                            @load="imgOriginLoaded"
                        >      

                        <svg
                            id="svg_imgOrigin"                        
                            ref="svg_imgOrigin" 
                            :style="{
                                left   : imgOrigin.left,
                                top    : '0px',
                                width  : '100%',
                                height : '100%',
                                pointerEvents : 'none',
                                position : 'absolute'
                            }"
                        >
                            <g 
                                :transform="'scale(' + imgOrigin.scale + ')'"
                            >
                                <path 
                                    v-bind="{    
                                        style : 'opacity:' + $store.state.setup.config.toolOpac/100,
                                        d : imgOriginPath_d
                                    }"
                                    stroke="red"
                                    stroke-width="5"
                                    fill="none"
                                />
                            </g>
                        </svg>
                    </div>

                    <div id="div_workAreaZoom"
                        class="workAreaZoom"
                        style="transform-origin: 0px 0px;background: lightblue;"
                        :style="{
                            ...workAreaZoomStyle,
                            }"                    
                    >
                        <medidorCMP id="medidor" 
                            ref="medidor"
                            style="width:0px; height:0px"
                            :style="{
                                opacity: GET_jobLoaded && GET_elemsLoaded ? 1 : 0
                            }"
                            :class="{ discardedImg : isDiscardedJob }"
                        >
                            <div id="div_mainImg" 
                                slot="mainImg"
                                style="position:absolute; width:fit-content; height:fit-content">
                                <img id="mainImg" 
                                    draggable="false"
                                    ref="mainImg"
                                    :style="{
                                        filter: 'brightness(' + GET_waImgBC.brightness + '%) contrast(' + GET_waImgBC.contrast + '%)',
                                    }"                                
                                    v-show="GET_jobLoaded ? GET_elemsLoaded : false"
                                    :src="activeImgSrc"
                                    @load="activeImgLoaded"
                                    :class="{
                                        mainImg : true,
                                        mainImg_border : GET_togglesImgOrigin
                                    }"
                                >  
                                
                                <!-- <UEI-BKP:1>
                                    Ainda tenho que checar com o Hiago como é o objeto com as anomImgs que o Cezar enviava ... 
                                    mas acho que era indexado pelo label (e se for vou passar a indexá-lo pelo labelId). 
                                -->
                                <img v-for="(anomHeatMap, labelId) in activeAnomHeatMaps"  
                                    :key="labelId"
                                    :id="'img_anomHeatMap_' + labelId"
                                    v-show="GET_activeLabel == labelId"
                                    :src="'data:image/jpg;base64,' + anomHeatMap"
                                    :style="{
                                        opacity : (GET_activeLabel == labelId) ? $store.state.setup.config.anomHeatMapOpac/100 : 0,
                                    }"
                                    class="img_anomHeatMap"
                                >
                            </div>

                        </medidorCMP>
                    </div>  <!-- div_workAreaZoom -->

                    <activeHudCMP></activeHudCMP>
                    <!-- <sidePanelsCMP :panels="GET_appSidePanels" :side="gConsts.ui.sidePanel.sides.LEFT" ></sidePanelsCMP>                
                    <sidePanelsCMP :panels="GET_appSidePanels" :side="gConsts.ui.sidePanel.sides.RIGHT"></sidePanelsCMP> -->
                </div>  <!-- div_workArea -->
                <sidebarPanels></sidebarPanels>

                <popupAnotacaoHandler></popupAnotacaoHandler>
                <segmentationFixHandler></segmentationFixHandler>
            </div>


            <footerCMP style="grid-area: footer;"></footerCMP>
        </div>
        <toastHandler placement="bottom-center"></toastHandler>
    </div>  <!-- app -->
</template>

// =========================================================================================
// =========================================================================================

<script>
    import medidorCMP    from './components/medidor.vue';
    import activeHudCMP  from './components/ui/activeHud.vue';
    import toolbarCMP    from './components/ui/toolbar.vue';
    import sidePanelsCMP from './components/panels/sidePanels.vue';
    import headerCMP from './components/layout/header/header.vue';
    import footerCMP from './components/layout/footer.vue';
    import sidebarPanels from './components/layout/sidebarPanels.vue';
    import popupAnotacaoHandler from './features/anotacoes/components/popupAnotacaoHandler.vue';
    import segmentationFixHandler from './features/tooth/components/segmentationFixHandler.vue';
    import toastHandler from './components/ui/toast/toastHandler.vue';

    import { mapActions, mapGetters, mapState } from 'vuex';
    import { gConsts  } from './globals/gConsts';
    import { utils    } from './globals/utils';
    import { undoRedoHistory } from './globals/undoRedo';
    import _ from 'lodash';

    import { evtBus } from './main';

    //import {router} from "./main.js"
    export default {
        name : 'AppCMP',

        components: {
            medidorCMP,
            activeHudCMP,
            // sidePanelsCMP,
            // toolbarCMP,
            headerCMP,
            footerCMP,
            sidebarPanels,
            popupAnotacaoHandler,
            segmentationFixHandler,
            toastHandler,
        },
        
        // -----------------------------------------------------------------

        data: () => ({
            gConsts : gConsts,
            mouseTarget : '',
            firstImgLoad : true,
            utils   : utils,
            localExec : false,
            appStarted : false,
            instanceName : 'predictions_00_name',

            imgOrigin : {
                left : 0,
                scale  : 1,
                ratio : 1,
                containerRatio : 1
            },

            toolbars : {
                imgButtons : {},
                toolButtons : { label: 'imgLabel', id: gConsts.ui.toolbar.buttons.IMG_LABEL, type: gConsts.tool.attrib.types.IMG_LABEL }
            },

            workArea: {
                movType: null,
                zoom: {
                    scale: 1,
                    offset: {
                        x: 0,
                        y: 0,
                    }
                }
            },

            popupAnotacoes: {
                visible: false,
                position: {
                    x: 0,
                    y: 0,
                },
                type: null, // 'interno' (dente) ou 'externo'
            }
        }),

        // -----------------------------------------------------------------

        computed: {
            ...mapState({
            }),

            // -----------------------------------------------------------------

            ...mapGetters([
                'GET_job',
                'GET_activeImg',
                'GET_activeLabel',
                'GET_elemsLoaded',
                'GET_jobLoaded',
                'GET_jobState',
                'GET_waImgBC',
                'GET_appToolbars',
                'GET_appSidePanels',
                'GET_colorTheme',
                'GET_togglesImgOrigin'
            ]),

            // -----------------------------------------------------------------

            workAreaCursorType() {
                let cursorType;

                switch (this.workArea.movType) {
                    case gConsts.mov.types.WA_PAN:
                        cursorType = 'grab';
                        break;
                    case gConsts.mov.types.IMG_BC:
                        cursorType = 'crosshair';
                        break;
                }

                if (!cursorType) {
                    switch (this.$store.state.ui.toolbar.button) {
                        case gConsts.ui.toolbar.buttons.WA_PAN:
                            cursorType = 'grab';
                            break;
                        case gConsts.ui.toolbar.buttons.IMG_BC:
                            cursorType = 'crosshair';
                            break;
                    }
                }
                return cursorType || 'pointer';
            },

            workAreaZoomStyle() {
                let zoom = this.workArea.zoom;
                // console.log('[AppCMP][workAreaZoomStyle] - [' + zoom.scale + ']' );

                return {
                    transform : 'translate(' + zoom.offset.x + 'px, ' + zoom.offset.y + 'px) ' +  
                                'scale(' + zoom.scale + ')'
//                    transition : this.appStarted ? 'transform ' + zoom.animate + 's ease-out' : 'none',
                }
            },

            // -----------------------------------------------------------------

            activeImgSrc() {         
                return this.GET_activeImg?.src ?? ''

                // return this.GET_jobLoaded
                //     ? require('./assets/imgs/pan.jpg')
                //     : ''

                    // gConsts.setup.io.server + 
                    // gConsts.setup.io.reqs.LOAD_IMG + 
                    // this.activeImg.src + '?auth='+ localStorage.getItem('auth')                    
            },

            // -----------------------------------------------------------------

            activeAnomHeatMaps() {
                return this.activeImg?.anomHeatMaps || {};                     
            },

            // -----------------------------------------------------------------

            imgOriginSrc() {
                return this.this.activeImg?.imgOrigin.src || '';
            },

            // -----------------------------------------------------------------

            imgOriginPath_d() {
                var idx, pts, 
                    imgOrigin = this.activeImg?.imgOrigin,
                    dStr = '';
                
                if (imgOrigin) {
                    pts = imgOrigin.coords;
                    dStr = 'M ' + pts[0].x + ' ' + pts[0].y;            
                    for (idx = 1; idx < pts.length; idx++) {
                        dStr += ' L ' + pts[idx].x + ' ' + pts[idx].y
                    }
                    dStr += ' Z';
                }

                return dStr;
            },

            // -----------------------------------------------------------------

            isDiscardedJob() {                
                return this.GET_elemsLoaded && 
                       (this.GET_jobState == gConsts.job.states.DISCARDED);
            },

            // -----------------------------------------------------------------

            folder() { return (this.$root.isEmbedded ? this.instanceName : this.$route.params.instanceName) },
            showRouter() { return (!this.$root.isEmbedded) },

            // -----------------------------------------------------------------

        },

        // -----------------------------------------------------------------

        watch: {
        //     '$route': function(){
        //         window.location.reload()
        //     },
        //     'active.job': function() {
        //         this.$nextTick(function() {
        //             // faz o scroll pra imagem selecionado caso necessario
        //             document.getElementById('li_img[' + this.$store.state.runtime.active.jobIdx + ']').scrollIntoViewIfNeeded();
        //         });                
        //     },
        },

        // -----------------------------------------------------------------

        methods: {
            ...mapActions([
                'ACT_setup',
                'ACT_loadJob',
                'ACT_runtimeUpdate',
                'ACT_uiUpdate',
            ]),

            // -----------------------------------------------------------------

            loadProjFromFile(evt) {
                const filename = evt.target.files[0];
                const fReader = new FileReader();
                fReader.onload = (evt) => {
                    var content = evt.target.result;
                    this.loadProjData(JSON.parse(content));
                };
                fReader.onerror = evt => {
                    console.error(evt);
                };
                fReader.readAsText(filename, "UTF-8");
            },

            // -----------------------------------------------------------------

            initialize(initData) {
                /* Mudanças no init.JSON recebido do servidor ...
                    Passar para o Diego as alterações e depois apagar do código,
                    pois não serão mais necessárias ... UEI !!! */
                initData['setup'] = {
                    appId    : initData.info.appId,
                    projId   : 'laudoPadrao', // initData.info.projId,
                    config   : null,
                    instance : null,
                    custom   : initData.custom,
                };

                initData['job'] = {
                    version : 1,
                    info    : { obs : '' },
                    state   : gConsts.job.states.EMPTY,
                    patient : initData.patient,
                    elems   : initData.elems,
                    tools   : initData.tools,
                    report  : initData.report
                };                

                initData.job.elems[0].labels = { 
                    'layer_tipoDenticao' : 'lb_denticaoPermanente'  // initData.job.elems[0].labels[0]  ... veio escrito errado :(
                }
                initData.job.tools.forEach(tool => {
                    if (tool.label.layer == gConsts.layer.locations.TEETH_LE) {
                        tool.attrib.type = gConsts.tool.attrib.types.RETA;
                    }
                    tool.label.vLabel = { x: 0, y: 0 }
                    if (tool.label.layer == 'layer_contornosAna') {  // escreveram errado, tem que passar pro romulo  UEI!!
                        tool.label.layer = 'layer_contornosAnat'
                    }
                    if (tool.label.layer == 'layer_cirurgiaImpOrto') { // Outro Vindo errado do backend
                        tool.label.layer = 'layer_cirurgiaImplantesOrto'
                    }
                });
                if (_.isEmpty(initData.job.elems[0].img.imgOrigin)) {
                    initData.job.elems[0].img.imgOrigin = null;  
                }

                // ---------------------------------------------------------------

                var pxPerMm, screenDPI,
                    divDPI = document.getElementById('divDPI'),
                    initParams = this.$root.initParams;
                                
                screenDPI = divDPI.offsetWidth,
                pxPerMm = screenDPI / 25.4;           
                divDPI.style.display = 'none';

                // Manobras necessárias por causa de modificações na estrutura do job.
                // swith (initData.job.version) {
                // }

                /* Inclui no [initData] dados coletados localmente 
                    - Informações passadas como param nos attrib HTML;
                    - Configuração local obtida do [localStorage];
                    - pxPerMm da tela. */                
                initData.setup['initParams'] = initParams;
                initData.setup['config'    ] = this.loadConfig();
                initData.setup['pxPerMm'   ] = pxPerMm;

                // Carrega o setup inicial e o job corrente.
                this.ACT_setup(initData.setup);
                this.ACT_loadJob(initData.job);
            },

            // -----------------------------------------------------------------

            activeImgLoaded: function() {
                this.ACT_runtimeUpdate({ events : { elemsLoaded : true } });
                if (this.firstImgLoad) {
                    this.$nextTick(function() {
                        this.$refs.medidor.fitToWorkArea();
                        this.firstImgLoad = false;
                        this.appStarted = true;
                        undoRedoHistory.reset();  // no 1o carregamento eu soh posso chamar o reset depois do fitToWA
                    });
                } else {
                    undoRedoHistory.reset();  // reseto o undo/redo history qdo mudo de imagem
                }
            },

            // -----------------------------------------------------------------

            imgOriginLoaded: function() {
                this.updateImgOrigin();
            },

            // -----------------------------------------------------------------

            updateImgOrigin: function() {
                var workArea = this.$refs['workArea'],
                    img_imgOrigin = this.$refs['img_imgOrigin'];

                if (this.GET_togglesImgOrigin) {
                    this.updateImgOrigin;
                    this.imgOrigin.containerRatio = workArea.offsetWidth / workArea.offsetHeight;    
                    this.imgOrigin.ratio = img_imgOrigin.offsetWidth / img_imgOrigin.offsetHeight;

                    this.$nextTick(() => {
                        this.imgOrigin.left  = img_imgOrigin.offsetLeft; 
                        this.imgOrigin.scale = this.getImgOriginScale();
                    });                
                }
            },

            // -----------------------------------------------------------------

            getImgOriginScale: function() {
                var img_imgOrigin = this.$refs['img_imgOrigin'];
                return img_imgOrigin.offsetWidth / img_imgOrigin.naturalWidth;
            },

            // -----------------------------------------------------------------

            winResize: function() {
                if (this.GET_togglesImgOrigin) {
                    this.updateImgOrigin();
                }
            },

            // -----------------------------------------------------------------

            loadConfig: function() {
                var instanceName, 
                    config = { ...this.$store.state.setup.config };  // shallow copy

                // Carrega (e já seta) dados do localStorage que não ficam no [setup.config] ------------------------
                instanceName = utils.localStorage_getItem('setup.instance.name', '');
                // O job corrente da instancia (quando presente) somente é carregado se estamos abrindo a mesma instancia
                if ((instanceName != '') && (instanceName == this.$store.state.setup.instance.name)) {
                    this.ACT_runtimeUpdate({ active : {
                        jobIdx : utils.localStorage_getItem('rt.active.jobIdx', 0)
                    } });
                }

                // Controla se o crossHair está ativo ou não
                this.ACT_uiUpdate({ toggles : {  
                    crossHair : utils.localStorage_getItem('ui.toggles.crossHair', false)
                } } );
                // --------------------------------------------------------------------------------------------------

                // Carrega e retorna as configurações que ficam registradas em [setup.config]
                config.closedPaths     = utils.localStorage_getItem('setup.config.closedPaths'    , false);
                config.selToothNav     = utils.localStorage_getItem('setup.config.toothNav'       , gConsts.dente.navTypes.DYNAMIC);
                config.centerTooth     = utils.localStorage_getItem('setup.config.centerTooth'    , false);
                config.labelOpac       = utils.localStorage_getItem('setup.config.labelOpac'      , 100);
                config.toolOpac        = utils.localStorage_getItem('setup.config.toolOpac'       , 100);
                config.dentesROIFactor = utils.localStorage_getItem('setup.config.dentesROIFactor', 10);

                return config;
            },

            setWorkAreaZoomStyleVariable: function(scale) {
                if (this.$el) {
                    const scaleNum = typeof scale === 'number' && !Number.isNaN(scale) ? Number(scale) : 1;
                    this.$el.style.setProperty(gConsts.ui.workArea.cssVars.zoom, scaleNum);
                }
            },
        },

        // =========================================================================================
        // Lifecycle hooks

        created() {
            window.addEventListener("resize", this.winResize);
//            this.loadProjData(demoProj)

            evtBus.$on('evt_workArea_zoom_update', (payload) => {
                if ('scale' in payload) {
                    this.workArea.zoom.scale = payload.scale;
                }
                if ('delta' in payload) {
                    this.workArea.zoom.offset.x += payload.delta.x;
                    this.workArea.zoom.offset.y += payload.delta.y;
                }

                this.$setWorkAreaZoomStyleVariable(payload.scale); // Atualiza a variável global de zoom
            });

            evtBus.$on('evt_workArea_movType_update', (payload) => {
                this.workArea.movType = payload.movType;
            });
        },

        // -----------------------------------------------------------------

        beforeDestroy() {
            window.removeEventListener("resize", this.winResize);
        },

        // -----------------------------------------------------------------

        mounted() {
            var errorMsg, rBotData,
                initParams = this.$root.initParams;

            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            // console.log("urlParams", urlParams.get('token'));

            // Teste sem login. O token do job passando pelo url. Se nao passar nao inicia
            if (!urlParams.get('token')) {
                return;
            }

            initParams.token = urlParams.get('token');

            if (this.$root.isEmbedded) {
//                rBotData = utils.localStorage_getItem('rBotDataDump', '');
                if (rBotData) {
                    this.initialize(JSON.parse(rBotData));
                    return;
                }

                this.$axios
                    .post(initParams.url, {}, { headers : { Authorization : initParams.token } })
                    .then(response => {
                        if (response.data.status == 200) {
                            utils.localStorage_setItem('rBotDataDump', JSON.stringify(response.data.data));
                            this.initialize(response.data.data)
                        } else {
                            console.log(`Erro no servidor : ${response.data.status} - ${response.data.msg}`);
                        }
                    })
                    .catch(error => console.log(`axios (erro inesperado) : ${error.name} / ${error.message}

${error.stack}`))

            } else {
                let token = localStorage.getItem('auth')
                this.loadConfig([gConsts.setup.config.types.GLOBAL]);
                
                if(!token)return;
                this.$axios
                    .post(gConsts.setup.io.server + gConsts.setup.io.reqs.LOAD_PROJ + this.folder, {token: token})
                    .then(response => {
    //                    console.log(response.data.status)
                        if ( (!this.$root.isEmbedded) && (response.data.status == 401) ) { // falha de permissao
                            if (this.$route.params.folder){
                                this.$router.push({
                                    path: '/login',
                                    query: { nextUrl: this.$route.params.folder}
                                })

                            }
                        } else if (response.status != 200) {  // qq outra falha cai aqui
                            errorMsg = 'Erro ao carregar o projeto: [' + response.status + '] ' + response.statusText;
                            console.log(errorMsg);
                            alert(errorMsg);
                        } else {
                            this.loadProjData(response.data, this.folder)
                            this.loadConfig([gConsts.setup.config.types.PROJ]);
                        }
                    }, this)
                    .catch(error => {
                        console.log('axios [getImgs] error: ' + error);
                        console.log(error.stack);
                    });
            }

            // -----------------------------------------------------------------
            this.$setWorkAreaZoomStyleVariable = _.debounce(this.setWorkAreaZoomStyleVariable, 150);
        }
    }
</script>

// =========================================================================================
// =========================================================================================

<style>
@import './components/ui/styles/_variables.css';

html, body {
    margin: 0;
    height: 100%;
    padding: 0px;
    font-family: Inter, sans-serif;
    font-size: 16px;
}

:root {
    --wa-zoom-scale : 1;  /* Variavel global de zoom gConsts.ui.workArea.cssVars.zoom */
}

/* Compartilhado */

.scrollbar {
    /* Firefox scrollbar styling */
    scrollbar-width: thin;
    scrollbar-color: #374151 transparent;
}

/* Webkit scrollbar styling */
.scrollbar::-webkit-scrollbar {
    width: 8px;
}

.scrollbar::-webkit-scrollbar-track {
    background: transparent;
}

.scrollbar::-webkit-scrollbar-thumb {
    background: #374151;
    border-radius: 4px;
}

.scrollbar::-webkit-scrollbar-thumb:hover {
    background: #374151;
}




/* Estilizacao do App.vue */

.rootElem {
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;
/*    left: 0px;
    height: 0px;
    padding: 0px;
    position: absolute; */
}

.ulMain {
    list-style: none;
    padding-left:0px;
    margin-top: 0px;
    position: relative;
    height: 100%;
    top: 0px;
    left: 0px;
    overflow: visible;
}

.liMain {
    cursor: pointer;
    padding-left:10px;    
    text-align: left;
    user-select : none;
    font-family: Verdana, Sans-Serif;
    overflow: visible;
    white-space: nowrap;
}

.selLi {    
    outline: 1px solid black;
    background: lightgreen;
}

.imgLabel {
    display: list-item;
    list-style: circle;
    font-weight: bold;
}

.discardedImg {
    opacity : 0.2;
}

.toolbarContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.toolbarSeparator {
    width: 1px;
    height: 20px;
    background: #dddddd;
    margin: 5px 0;
    align-self: center;
}

/*
Essa classe/CSS fez a imagem redimensionar sem independente do zoom o que mudou a magnificacao 
sem atualizar os params da imagem e fez as coordenadadas das tools desincronizarem 
com a imagem ... estou deixando aqui somente para lembrar desse comportamento interessante.
.mainImg {
    max-height:100%; 
    max-width:100%;
}
*/

.workAreaZoom {
    transition: transform 30ms linear;
}

.workArea[data-cursor-type="pointer"] {
    cursor: pointer;
}

.workArea[data-cursor-type="crosshair"] {
    cursor: crosshair;
}

.workArea[data-cursor-type="grab"] {
    cursor: grab;
}

.workArea[data-cursor-type="grab"]:active {
    cursor: grabbing;
}

.mainImg {
    border-radius: 20px;
}

#div_appTitle {
    display: flex;
    width: 160px; 
    height: 100%; 
    margin-left:0px; 
    margin-right: auto;
    padding: auto;
}

#div_appTitle > .appTitleText {
    font-family: 'Inter', Tahoma, Geneva, Verdana, sans-serif;
    color: white; 
    margin:auto; 
    font-size:18px;
    font-weight: bold;
    letter-spacing: 1px;
}

.buttonImg {
    margin:auto;
    width:25px;
    height:25px;
}

#div_grid_container {
    text-align: center;
    width: 100%;
    height: 100%;
    display : grid;
    grid-template-rows : 54px auto 30px;
    grid-template-columns : auto;
    grid-template-areas :
        "header  "
        "workArea"
        "footer  ";
    grid-gap: 0px;
    padding: 0px;
}

#header {
    grid-area: header;
    box-shadow: 0px 2px 5px -2px #000000;
    z-index: 40;
}

#div_toolBars {
    background: #eeeeee;
    grid-area: toolBar;
    z-index: 10;
    /* box-shadow: 0px 2px 5px -2px #000000; */
    border-bottom: 1px solid #D5DDE1;
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.div_workArea_container {
    position: relative;
    width: 100%;
    height: 100%;
    grid-area: workArea;
}

#div_workArea {
    background: #f5f5f5;
    height: 100%;
    overflow: hidden;
    box-shadow: 3px 0px 4px -2px rgba(150, 150, 150, 0.7);    
}

.mainImg_border {
    box-shadow: 0px 0px 5px 3px rgba(70, 30, 30, 1);    
}

.img_anomHeatMap {
    position : absolute;
    width    : 100%;
    height   : 100%;
    top      : 0px;
    left     : 0px;
    mix-blend-mode: color;
}

/*
.img_anomHeatMap::after{
    position: absolute; 
    width: 100%; 
    height: 100%;
    content: ""; 
    background: #00FF00; 
    mix-blend-mode: multiply; 
}
*/

/*
.denteROI-enter-active,
.denteROI-leave-active {
  transition: opacity 0.5s ease;
}

.denteROI-enter-from,
.denteROI-leave-to {
  opacity: 0;
}
*/

/* Animacoes */
.animate-fade-in {
    animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}
</style>